/**
 * External Imports
 */
import styled from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuButton } from '@neutron/react';

export const StyledAddBtn = styled(NeuButton)<{ minWidth: number }>`
  > button {
    font-size: 1rem;
    min-width: ${({ minWidth }) => minWidth}rem !important;
  }
`;
